import axios from "axios";
import { refreshAccessTokenInterceptor } from "../utils/refreshTokens";
import { fullAPIURL } from "../utils/requests";
import {
  requestAccessTokenInterceptor,
  responseStatusInterceptor,
} from "../utils/axios.utils";
import type { SendMessageType } from "../pages/People/types";

const messagesAxios = axios.create({
  baseURL: `${fullAPIURL}/v2/communications/`,
  headers: { "Content-Type": "application/json" },
  validateStatus: null,
});

messagesAxios.interceptors.request.use(requestAccessTokenInterceptor);

messagesAxios.interceptors.request.use(refreshAccessTokenInterceptor);

messagesAxios.interceptors.response.use(responseStatusInterceptor);

export const sendSMS = async (message: string, to: string) => {
  return await messagesAxios.post("sms/send", { message, to });
};

export const sendMessage = async (data: SendMessageType) => {
  return await messagesAxios.post("queue-messages", data);
};
